<template>
  <div class="flex flex-col items-center pb-28">
    <div class="container flex flex-col items-center self-stretch w-full max-md:px-5 max-md:max-w-full pt-24">
      <!-- Page Title -->
      <div class="self-start responsive-title-2 text-black max-md:max-w-full">
        {{ $t('whyBook.header') }}
      </div>
      
      <div class="mt-8 responsive-body-large text-black mix-blend-multiply max-md:max-w-full">
        {{ $t('whyBook.body') }}
      </div>
      

      <!-- Steps Section -->
      <div class="w-full max-md:max-w-full">
        <!-- Step Rows -->
        <div v-for="(step, index) in steps" :key="index" class="flex gap-0 mt-14 max-md:flex-col md:gap-15 md:mt-20 ">
          <div class="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div class="flex flex-col font-semibold max-md:mt-0 max-md:max-w-full">
              <div
                  class="flex justify-center items-center responsive-body-small text-white whitespace-nowrap bg-primary-blue rounded-full h-7.5 w-7.5">
                {{ step.number }}
              </div>
              <div class="mt-2.5 responsive-body-large text-black max-md:max-w-full">
                {{ step.title }}
              </div>
              <div class="mt-4 responsive-body-medium font-normal text-neutral-400 max-md:max-w-full">
                {{ step.description }}
              </div>
            </div>
          </div>
          <div class="flex flex-col md:ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div class="flex flex-col font-semibold max-md:mt-10 max-md:max-w-full">
              <div
                  class="flex justify-center items-center responsive-body-small text-white whitespace-nowrap bg-blue-500 rounded-full h-7.5 w-7.5">
                {{ step.subNumber }}
              </div>
              <div class="mt-2.5 responsive-body-large text-black max-md:max-w-full">
                {{ step.subTitle }}
              </div>
              <div class="mt-4 responsive-body-medium font-normal text-neutral-400 max-md:max-w-full">
                {{ step.subDescription }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  name: "WhyBook",
  setup() {
    const { t } = useI18n();
    const steps = reactive([
      {
        number: "1",
        title: t('whyBook.items[0].title'),
        description: t('whyBook.items[0].description'),
        subNumber: "2",
        subTitle: t('whyBook.items[0].subTitle'),
        subDescription: t('whyBook.items[0].subDescription'),
      },
      {
        number: "3",
        title: t('whyBook.items[1].title'),
        description: t('whyBook.items[1].description'),
        subNumber: "4",
        subTitle: t('whyBook.items[1].subTitle'),
        subDescription: t('whyBook.items[1].subDescription'),
      },
      {
        number: "5",
        title: t('whyBook.items[2].title'),
        description: t('whyBook.items[2].description'),
        subNumber: "6",
        subTitle: t('whyBook.items[2].subTitle'),
        subDescription: t('whyBook.items[2].subDescription')
      },
      {
        number: "7",
        title: t('whyBook.items[3].title'),
        description: t('whyBook.items[3].description'),
        subNumber: "8",
        subTitle: t('whyBook.items[3].subTitle'),
        subDescription: t('whyBook.items[3].subDescription')
      }
    ]);

    return {
      steps,
    };
  },
};
</script>

